// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { agentPrincipalStatusGuard, agentTrustLevelGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().nullable().optional(),
    email: z.string().min(1).max(256),
    status: agentPrincipalStatusGuard.optional(),
    trustLevel: agentTrustLevelGuard.optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().nullable(),
    email: z.string().min(1).max(256),
    status: agentPrincipalStatusGuard,
    trustLevel: agentTrustLevelGuard,
    createdAt: z.number(),
});
export const AgentPrincipals = Object.freeze({
    table: 'agent_principals',
    tableSingular: 'agent_principal',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        description: 'description',
        email: 'email',
        status: 'status',
        trustLevel: 'trust_level',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'description',
        'email',
        'status',
        'trustLevel',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
